<template>
    <div
        class="grid text-xl font-bold tracking-wide sm:grid-cols-9">
        <span class="flex items-center col-span-3">
          Showing {{ paginationObject.from || 0 }} - {{ paginationObject.to || 0 }} of {{ paginationObject.total }}
        </span>
        <span class="col-span-2"></span>
        <!-- Pagination -->
        <span class="flex col-span-4 mt-2 sm:mt-auto sm:justify-end">
            <nav aria-label="Table navigation">
                <ul class="inline-flex items-center">
                    <li v-for="(link,key) in paginationObject.links" class="flex items-center mx-1">
                        <template v-if="link.label === '...'">
                            <span class="px-3 py-1">...</span>
                        </template>
                        <template v-else-if="key === 0">
                            <button @click="visit(link.url)"
                                    class="px-3 py-1"
                                    aria-label="Previous">
                                <svg class="w-3 h-5 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                                    <path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"/>
                                </svg>
                            </button>
                        </template>
                        <template v-else-if="key === paginationObject.links.length-1">
                            <button @click="visit(link.url)"
                                    class="px-3 py-1"
                                    aria-label="Next">
                                <svg class="w-3 h-5 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                                    <path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"/>
                                </svg>
                            </button>
                        </template>
                        <template v-else>
                            <button @click="visit(link.url)"
                                    class="w-9 h-9 inline-flex items-center justify-center transition-all duration-150 font-bold rounded-md"
                                    :class="link.active ? 'bg-dark text-white ' : 'bg-light text-dark'"
                                    v-html="link.label"
                            />
                        </template>
                    </li>
                </ul>
          </nav>
        </span>
    </div>
</template>

<script>
import {Inertia} from '@inertiajs/inertia';

export default {
    name: "TablePagination",
    props: {
        paginationObject: Object,
        preserveScroll: {
            type: Boolean,
            default: false,
        },
        preserveState: {
            type: Boolean,
            default: false
        },
        inertiaVisitOptions: {
            type: Object,
            default: {},
        }
    },
    emits: ['start-visit', 'finish-visit'],
    setup(props, {emit}) {
        const visit = (url) => Inertia.visit(url, {
            method: 'get',
            preserveScroll: props.preserveScroll,
            preserveState: props.preserveState,
            onStart: () => {
                emit('start-visit');
            },
            onFinish: () => {
                emit('finish-visit');
            },
            ...props.inertiaVisitOptions
        });

        return {
            visit,
        }
    }
}
</script>

<style scoped>

</style>
